import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams, useLocation, useNavigate } from "react-router-dom";
import { getRegistration, getRegisterUser, message, requestRegister, getSubsite } from '../reducers/auth';
import * as Yup from 'yup';
import { Formik } from 'formik';
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import AuthService from "../services/auth.service";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

const RequestRegistrationSuccess = () => {

  return (
    <div className="container">
        <div style={{ marginTop: 10, marginBottom: 70 }}>
         <h3>Request Registration</h3>
          <p>Your registraion request has been submitted.  If you are approved, an email will be sent so you can register for an account.</p>
        </div>
    </div>
  );
};
export default RequestRegistrationSuccess;